module.exports = __webpack_public_path__ + "img/homepage_logo.8a454e12.png";